import {
  BusinessRelationship,
  ClientType,
} from 'modules/onboarding/common/components';

import { isGlobalProject } from '../../../../config';
import { useTranslation } from '../../../../libs/i18n';
import { useOwnerBusinessRelationship } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerBusinessRelationshipStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { submitLoading, initialValues, onSubmit, goToBack } =
    useOwnerBusinessRelationship();

  const { t } = useTranslation();

  return (
    <BusinessRelationship
      canGoBack={canGoBack}
      clientType={ClientType.Client}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={
        isGlobalProject()
          ? t('onboarding.businessRelationship.ownerSubtitle')
          : undefined
      }
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
